import React from 'react';
import { Link } from 'react-router-dom';
import LaxDiv from '../Shared/LaxDiv';
 
class Cta extends React.Component {
    render(){
        const data = [
            {
                id:1,
                subheading:"BAG",
                image: require("../../assets/images/bag.svg"),
                color: '#F04C31'

               
            },

            {
                id:2,
                subheading:"T-SHIRT",
                image: require("../../assets/images/tshirt.svg"),
                color: '#00acee'

            },

            {
                id:3,
                subheading:"CAP",
                image: require("../../assets/images/cap.svg"),
                color: '#8dc63f'

            },

            {
                id:4,
                subheading:"SURPRISE BOX",
                image:require("../../assets/images/gift.svg"),
                color: '#efa506'

            },
           
        ];
        return (
            <>
                <div className="container">
                    <div className="section-title">
                        <span>Kit</span>
                        <h2>PROPOSED REGISTRATION KIT</h2>
                        <div className="bar"></div>
                        <LaxDiv text="KITKAT" dataPreset="driftRight" />
                        {/* <Link to="#" className="btn btn-primary">View More Speakers</Link> */}
                    </div>
                </div>
            {data.map(i => 
            <section className="cta-area" style={{ backgroundColor: i.color}}>
                
                <div className="container">
              
                    <div className="row h-100 " style={{justifyContent:"center",}}>
                        <div className="col-lg-6" style={{     alignSelf: 'center'}}>
                            {/* <h3>PROPOSED REGISTRATION KIT</h3> */}
                            <h3>{i.subheading}</h3>
                        </div>

                        <div className="col-lg-3 ">
                            {/* <Link to="#" className="btn btn-secondary">Buy Ticket!</Link> */}
                            <img src={i.image} style={{ height: '5rem'}}/>
                        </div>
                    </div>
                </div>
            </section>
            )}
            </>
        );
    }
}
 
export default Cta;